import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "arrow-left" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M6.66634 3.66602L2.33301 7.99935L6.66634 12.3327M2.66634 7.99935H13.6663",
        stroke: "#7F7F83",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }